import React, { memo } from 'react';

import { COMPARATORS } from '../../../../global/Predicates/ComparatorSelector';
import { NEGATE_MODES } from '../../../../global/Predicates/Negate';
import Filter, { createFilterChangeHandler } from '../Filter';
import TextField from '../ValueComponents/TextField';

/** @typedef {import('../../../../global/Predicates/Negate').NegateMode} NegateMode */
/** @typedef {import('../../../../global/Predicates/TypeSelector').Type} Type */

/** @type {Type[]} */
const OptinTypes = [
  {
    title: 'Optin Source',
    value: 'optinSource',
    comparators: [
      COMPARATORS.eq, COMPARATORS.stringContains,
    ],
  },
];

const getDefaultNegate = () => ({ mode: NEGATE_MODES.no });
const getDefaultType = () => OptinTypes[0].value;
const getDefaultComparator = () => COMPARATORS.eq.value;
const getDefaultValue = () => '';

export const valueMapper = (values) => values.map(({ id, ...value }) => value);

/**
 *
 * @param {Object} props
 * @param {String} props.id
 * @param {Function} props.onChange
 * @param {String} props.value
 * @param {NegateMode} props.negate
 * @param {String} props.type
 * @param {String} props.comparator
 */
const OptinFilter = (props) => {
  const {
    type = getDefaultType(),
    value = getDefaultValue(),
    negate = getDefaultNegate(),
    comparator = getDefaultComparator(),
    onChange,
    id,
  } = props;

  const optinType = OptinTypes.find((t) => t.value === type);

  const onFilterChange = createFilterChangeHandler({
    id, type, value, negate, comparator, onChange,
  });

  if (!optinType) {
    return null;
  }

  return (
    <Filter
      negate={negate}
      comparator={comparator}
      type={type}
      onChange={onFilterChange}
      types={OptinTypes}
      comparators={optinType.comparators}
      value={(
        <TextField value={value} onChange={onFilterChange} />
      )}
    />
  );
};

export default memo(OptinFilter);
